<template>
  <div class="emcee_center">
    <van-col span="24" class="emcee_data_income_title">
      <van-col span="18"><b>{{ $t('column.revenue_data') }}</b></van-col>
      <van-col span="6" class="emcee_center_select_income_detail" @click="emcee_income_log">{{ $t('column.view_details')}} ></van-col>
    </van-col>
    <van-col span="24" class="emcee_data_top_income_data">
      <van-row>
        <van-col span="12">
          <van-row class="emcee_data_top_day_income">
            <van-col span="24" class="emcee_data_income_number">{{day_ticket}}</van-col>
            <van-col span="24" class="emcee_data_top_data_number_title">{{ $t('column.today_revenue')}} {{ticket_name}}</van-col>
          </van-row>
        </van-col>
        <van-col span="12">
          <van-row class="emcee_data_top_day_income">
            <van-col span="24" class="emcee_data_income_number">{{all_ticket}}</van-col>
            <van-col span="24" class="emcee_data_top_data_number_title">{{ $t('column.accumulated_income')}}{{ticket_name}}</van-col>
          </van-row>
        </van-col>
      </van-row>
    </van-col>
    <van-col class="emcee_data_top_line" span="24">
      <van-divider/>
    </van-col>

    <van-col span="24" class="emcee_data_income_title">
      <van-col span="18"><b>{{ $t('column.view_details')}}</b></van-col>
      <van-col span="6" class="emcee_center_select_income_detail" @click="emcee_center_select_live_time">{{ $t('column.view_details')}} >
      </van-col>
    </van-col>
    <van-col span="24" class="emcee_data_top_income_data">
      <van-row>
        <van-col span="12">
          <van-row class="emcee_data_top_day_income">
            <van-col span="24" class="emcee_data_income_number">{{day_live_time}}</van-col>
            <van-col span="24" class="emcee_data_top_data_number_title">{{ $t('column.live_broadcast_duration_today')}}</van-col>
          </van-row>
        </van-col>
        <van-col span="12">
          <van-row class="emcee_data_top_day_income">
            <van-col span="24" class="emcee_data_income_number">{{month_live_time}}</van-col>
            <van-col span="24" class="emcee_data_top_data_number_title">{{ $t('column.duration_of_the_month')}}</van-col>
          </van-row>
        </van-col>
      </van-row>
    </van-col>
  </div>
</template>

<script>
    import Toast from "vant/lib/toast"
    import axios from 'axios'

    export default {
        data() {
            return {
                day_ticket: 0,
                all_ticket: 0,
                day_live_time: 0,
                month_live_time: 0,
                ticket_name: '',
            }
        },
        name: "emcee_center",
        created: function () {
            document.title = this.$t('title.emcee_center')
            this.initData()
        },
        methods: {
            emcee_center_select_live_time() {
                const token = this.$route.query.token
                this.$router.push({path: '/emcee_center_select_live_time', query: {token: token}});
            },
            emcee_income_log() {
                //收益记录
                const token = this.$route.query.token
                this.$router.push({path: '/emcee_income_log', query: {token: token}});
            },
            initData: function () {
                const token = this.$route.query.token
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=emcee_center&act=get_emcee_center_data", {
                    params: {
                        token: token,
                    }
                }).then(res => {
                    console.log(res.data)
                    this.day_ticket = res.data.day_ticket;
                    this.all_ticket = res.data.all_ticket;
                    this.day_live_time = res.data.day_live_time;
                    this.month_live_time = res.data.month_live_time;
                    this.ticket_name = res.data.ticket_name;
                })
            }
        }
    }
</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/emcee_center.vue